<script>
  import Logo from 'images/gateways/waenergy/logo-waenergy-gateway.png'
</script>

<a href="/">
  <img src={Logo} alt={window.gettext('Washington Columbia Plateau Least-Conflict Solar Siting')}/>
  <h1>
    <span>{window.gettext('Washington Columbia Plateau')}</span>
    <span class="sub-header">{window.gettext('Least-Conflict Solar Siting Gateway')}</span>
  </h1>
</a>

<style lang="scss">
  a {
    display: flex;
    font-family: Arial, Montserrat, sans-serif, Helvetica;
    align-items: center;
    padding-left: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }

    img {
      height: 64px;
      margin: 0 18px 0 12px;
    }

    h1 {
      font-size: $font-size-4;
      color: $gray-4;
      width: 450px;
      line-height: 1.2;

      .sub-header {
        display: block;
        font-size: $font-size-3;
      }
    }
  }
</style>
